export default __webpack_public_path__ + "72babb8a95bb722798de819d16c72993.svg";